"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var JobStatus;
(function (JobStatus) {
    JobStatus["QUEUED"] = "QUEUED";
    JobStatus["PROCESSING"] = "PROCESSING";
    JobStatus["FAILED"] = "FAILED";
    JobStatus["DONE"] = "DONE";
    JobStatus["CANCELLED"] = "CANCELLED";
    JobStatus["Queued"] = "QUEUED";
    JobStatus["Processing"] = "PROCESSING";
    JobStatus["Failed"] = "FAILED";
    JobStatus["Done"] = "DONE";
    JobStatus["Cancelled"] = "CANCELLED";
})(JobStatus || (exports.JobStatus = JobStatus = {}));
